
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1609845959817",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1466",
    "data-darkreader-inline-fill": "",
    "width": "64",
    "height": "64"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M621.76 139.072l166.4 190.592v530.816h-524.8V139.072h358.4M651.584 40.704H197.888A32.768 32.768 0 0 0 165.12 73.472v852.544a32.768 32.768 0 0 0 32.768 32.768h655.808a32.768 32.768 0 0 0 32.768-32.768v-620.8a32.768 32.768 0 0 0-8.064-21.568L676.288 52.096a32.832 32.832 0 0 0-24.704-11.2z",
        "p-id": "1467",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M384.384 401.408m49.216 0l186.432 0q49.216 0 49.216 49.216l0-0.064q0 49.216-49.216 49.216l-186.432 0q-49.216 0-49.216-49.216l0 0.064q0-49.216 49.216-49.216Z",
        "p-id": "1468",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M384.384 581.76m49.216 0l186.432 0q49.216 0 49.216 49.216l0-0.064q0 49.216-49.216 49.216l-186.432 0q-49.216 0-49.216-49.216l0 0.064q0-49.216 49.216-49.216Z",
        "p-id": "1469",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    }
  ]
})
    }
  